<template>
  <div class="service">
    <Loading v-if="serviceLoading" />
    <template v-else>
      <div class="service__title">
        <div class="service__name">{{ service[`long_${language}`] }} </div>
        <div class="icon icon__delete" @click="removeService()"></div>
      </div>

      <div v-if="!dropdownModels.length">
        <div class="service__fields number-status-fields" v-if="
          singletonModelIndex !== null &&
          singletonFormModels[singletonModelIndex] &&
          isFirstServiceOfBranch
        ">
          <div class="service__field">
            <input type="text" class="input input--default input--shadow" placeholder="Policy Number" :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_number : ''
              " @input="
                $store.commit('setSpecificSingletonFormModel', {
                  index: singletonModelIndex,
                  key: 'policy_number',
                  data: $event.target.value,
                })
                " />
          </div>
          <div class="service__field">
            <VSelect :options="options" :reduce="(policy) => policy.id" label="name"
              class="select select--default select--shadow" placeholder="Status" :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_status_id : null
                " @update:modelValue="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'policy_status_id',
                    data: $event,
                  });
                " :class="{
                  'input--error':
                    singletonFormModels[singletonModelIndex] &&
                    singletonFormModels[singletonModelIndex].policy_statusHasError
                }" />
            <div class="form__error"
              v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].policy_statusHasError">
              Status is required
            </div>
          </div>
          <div class="service__field" v-if="
            singletonFormModels[singletonModelIndex] &&
            singletonFormModels[singletonModelIndex].policy_status_id == 1
          ">
            <Datepicker class="input input--default input--shadow" placeholder="Submission Date"
              :config="statics.datePickerConfig"
              :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].submit_date : null"
            @change="
              handleDateInput($event, null, 'submit_date', 'singleModel');
              $store.commit('setSpecificSingleModel', {
                key: 'submit_dateHasError',
                data: false
              });
            "
              :class="{ 'input--error': singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError }" />
            <div class="form__error"
              v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError">
              Submission date is required
            </div>
          </div>
        </div>

        <div class="service_fields non-kvg">
          <div class="service__field">
            <Datepicker class="input input--default input--shadow" :class="{
              'input--error':
                singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].startDateHasError,
            }" placeholder="Start Date" :config="statics.datePickerConfig"
              :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].startDate : null"
              @change="handleDateInput($event, singletonModelIndex, 'startDate', 'singletonModel')" />
            <div class="form__error"
              v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].startDateHasError">
              Invalid date
            </div>
          </div>
          <template v-if="service.code != 'MM'">
            <div class="service__field">
              <Datepicker class="input input--default input--shadow" placeholder="End Date"
                :config="statics.datePickerConfig"
                :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].endDate : null"
                @change="handleDateInput($event, singletonModelIndex, 'endDate', 'singletonModel')" />
            </div>
            <div class="service__field">
              <input type="text" class="input input--default input--shadow" :class="{
                'input--error':
                  singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].priceHasError,
              }" placeholder="Price" @input="
                $store.commit('setSpecificSingletonFormModel', {
                  index: singletonModelIndex,
                  key: 'price',
                  data: $event.target.value,
                })
                " />
              <div class="form__error"
                v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].priceHasError">
                Invalid price value
              </div>
            </div>
            <div class="service__field">
              <VSelect class="select select--default select--shadow" :options="intervals"
                :reduce="(interval) => interval.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                :placeholder="intervals[3].name" @update:modelValue="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'interval',
                    data: $event,
                  })
                  " />
            </div>
            <div class="service__field" v-if="service.id == 11">
              <input type="text" class="input input--default input--shadow"
                :placeholder="$t(`addCompanyContactModal.${'mark'}`)" @input="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'plateNumber',
                    data: $event.target.value,
                  })
                  " />
            </div>
          </template>
        </div>
      </div>

      <template v-else>
        <template v-if="service.id !== KVG">
          <div class="policy__service-toggler">
            <span>Models</span>
            <div class="policy__service-adder" :class="{
              'policy__service-adder--active': showModelsDropdown,
            }" @click="showModelsDropdown = !showModelsDropdown"></div>

            <transition name="fade">
              <div class="service-dropdown" v-if="showModelsDropdown">
                <div class="service-dropdown__content">
                  <div class="service-dropdown__title">
                    Choose Models
                  </div>

                  <div class="service-dropdown__body">
                    <div v-if="!dropdownModels.length" class="service-dropdown__no-data">
                      No models found
                    </div>

                    <template v-else>
                      <div class="service-dropdown__item" v-for="model in dropdownModels" :key="model.id">
                        <div class="checkbox">
                          <input type="checkbox" class="checkbox__checkbox"
                            :checked="models.some((m) => m.id === model.id)" :id="model.id"
                            @input="addOrRemoveModels($event, model)" />

                          <label :for="model.id" class="checkbox__label checkbox__label--smaller"></label>
                        </div>
                        <label :for="model.id" class="service-dropdown__item-title">
                          {{ model.name }}
                        </label>
                      </div>
                    </template>
                  </div>

                  <div class="service-dropdown__buttons">
                    <button type="button" class="service-dropdown__button service-dropdown__button--submit"
                      @click="applyModels()"></button>
                    <button type="button" class="service-dropdown__button service-dropdown__button--cancel"
                      @click="showModelsDropdown = false"></button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </template>

        <template v-else>
          <div class="model">
            <div class="service__fields number-status-fields"
              v-if="isFirstServiceOfBranch && (service.id === KVG || (singletonModelIndex !== null && singletonFormModels[singletonModelIndex]))">

              <div class="service__field">
                <input type="text" class="input input--default input--shadow" placeholder="Policy Number"
                  :value="service.id === KVG ? singleModel.policy_number : (singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_number : '')"
                  @input="
                    service.id === KVG
                      ? $store.commit('setSpecificSingleModel', { key: 'policy_number', data: $event.target.value })
                      : $store.commit('setSpecificSingletonFormModel', { index: singletonModelIndex, key: 'policy_number', data: $event.target.value })
                    " />
              </div>

              <div class="service__field">
                <VSelect :options="options" :reduce="(policy) => policy.id" label="name"
                  class="select select--default select--shadow" placeholder="Status"
                  :value="service.id === KVG ? singleModel.policy_status_id : (singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_status_id : null)"
                  @update:modelValue="
                    service.id === KVG
                      ? (
                        $store.commit('setSpecificSingleModel', {
                          key: 'policy_status_id',
                          data: $event
                        }),
                        $store.commit('setSpecificSingleModel', {
                          key: 'submit_dateHasError',
                          data: false
                        })
                      )
                      : $store.commit('setSpecificSingletonFormModel', {
                        index: singletonModelIndex,
                        key: 'policy_status_id',
                        data: $event
                      })
                    " :class="{
                      'input--error': service.id === KVG ? singleModel.policy_statusHasError : (singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].policy_statusHasError)
                    }" />
              </div>

              <div class="service__field"
  v-if="(service.id === KVG 
    ? singleModel.policy_status_id 
    : (singletonFormModels[singletonModelIndex] 
        ? singletonFormModels[singletonModelIndex].policy_status_id 
        : null)) == 1">

  <Datepicker
    class="input input--default input--shadow"
    placeholder="Submission Date"
    :class="{
      'input--error': service.id === KVG 
        ? singleModel.submit_dateHasError 
        : (singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError)
    }"
    :value="service.id === KVG 
      ? singleModel.submit_date 
      : (singletonFormModels[singletonModelIndex] 
          ? singletonFormModels[singletonModelIndex].submit_date 
          : null)"
    @change="
      service.id === KVG 
        ? (
          handleDateInput($event, null, 'submit_date', 'singleModel'),
          $store.commit('setSpecificSingleModel', {
            key: 'submit_dateHasError',
            data: false
          })
        )
        : (
          handleDateInput($event, singletonModelIndex, 'submit_date', 'singletonModel'),
          $store.commit('setSpecificSingletonFormModel', {
            index: singletonModelIndex,
            key: 'submit_dateHasError',
            data: false
          })
        )
    "
  />

  <div class="form__error"
    v-if="service.id === KVG 
      ? singleModel.submit_dateHasError 
      : (singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError)">
    Submission date is required
  </div>

</div>
            </div>

            <div class="model__field">
              <VSelect class="select select--default select--model-dropdown select--shadow" :options="dropdownModels"
                :reduce="(model) => model.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                :value="singleModel.id" @update:modelValue="
                  $store.commit('setSpecificSingleModel', {
                    key: 'id',
                    data: $event,
                  })
                  " />
            </div>
            <div class="model__fields">
              <div class="model__field">
                <Datepicker class="input input--default input--shadow"
                  :class="{ 'input--error': singleModel && singleModel.startDateHasError }" placeholder="Start Date"
                  :config="statics.datePickerConfig" :value="singleModel ? singleModel.startDate : null"
                  @change="handleDateInput($event, null, 'startDate', 'singleModel')" />
                <div class="form__error" v-if="singleModel && singleModel.startDateHasError">
                  Invalid date
                </div>
              </div>
              <div class="model__field">
                <Datepicker class="input input--default input--shadow" placeholder="End Date"
                  :config="statics.datePickerConfig" :value="singleModel ? singleModel.endDate : null"
                  @change="handleDateInput($event, null, 'endDate', 'singleModel')" />
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="dropdownFranchises"
                  :reduce="(franchise) => franchise.id" label="franchise" :appendToBody="true"
                  :calculatePosition="withPopper" placeholder="Franchise" @update:modelValue="
                    $store.commit('setSpecificSingleModel', {
                      key: 'franchise',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="accidents"
                  :reduce="(accident) => accident.value" label="title" :appendToBody="true"
                  :calculatePosition="withPopper" placeholder="Accident" @update:modelValue="
                    $store.commit('setSpecificSingleModel', {
                      key: 'accident',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field">
                <input type="text" class="input input--default input--shadow" placeholder="Doctor name" @input="
                  $store.commit('setSpecificSingleModel', {
                    key: 'doctorName',
                    data: $event.target.value,
                  })
                  " />
              </div>
              <div class="model__field">
                <input type="text" class="input input--default input--shadow"
                  :class="{ 'input--error': singleModel.priceHasError }" placeholder="Price" @input="
                    $store.commit('setSpecificSingleModel', {
                      key: 'price',
                      data: $event.target.value,
                    })
                    " />
                <div class="form__error" v-if="singleModel.priceHasError">
                  Invalid price value
                </div>
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="intervals"
                  :reduce="(interval) => interval.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                  :placeholder="intervals[3].name" @update:modelValue="
                    $store.commit('setSpecificSingleModel', {
                      key: 'interval',
                      data: $event,
                    })
                    " />
              </div>
            </div>
          </div>
        </template>

        <div class="models">
          <div class="model model--multiple" v-for="(model, index) in models" :key="model.id">
            <div class="model__name">{{ model.name }}</div>
            <div class="service__fields number-status-fields" v-if="isFirstServiceOfBranch">
              <div class="service__field">
                <input type="text" class="input input--default input--shadow" placeholder="Policy Number"
                  :value="formModels[index] ? formModels[index].policy_number : ''" @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'policy_number',
                      data: $event.target.value,
                    })
                    " />
              </div>
              <div class="service__field">
                <VSelect :options="options" :reduce="(policy) => policy.id" label="name"
                  class="select select--default select--shadow" placeholder="Status"
                  :value="formModels[index] ? formModels[index].policy_status_id : null" @update:modelValue="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'policy_status_id',
                      data: $event,
                    });
                  " :class="{ 'input--error': formModels[index] && formModels[index].policy_statusHasError }" />
                <div class="form__error" v-if="formModels[index] && formModels[index].policy_statusHasError">
                  Status is required
                </div>
              </div>
              <div class="service__field" v-if="formModels[index] && formModels[index].policy_status_id == 1">
                <Datepicker class="input input--default input--shadow" placeholder="Submission Date"
                  :config="statics.datePickerConfig" :value="formModels[index] ? formModels[index].submit_date : null"
                  @change="handleDateInput($event, index, 'submit_date', 'formModel'); $store.commit('setSpecificFormModel', { index, key: 'submit_dateHasError', data: false });"
                  :class="{ 'input--error': formModels[index] && formModels[index].submit_dateHasError }" />
                <div class="form__error" v-if="formModels[index] && formModels[index].submit_dateHasError">
                  Submission date is required
                </div>
              </div>
            </div>

            <div class="model__fields">
              <div class="model__field">
                <Datepicker class="input input--default input--shadow" :class="{
                  'input--error': formModels[index] && formModels[index].startDateHasError,
                }" placeholder="Start Date" :config="statics.datePickerConfig"
                  :value="formModels[index] ? formModels[index].startDate : null"
                  @change="handleDateInput($event, index, 'startDate', 'formModel')" />
                <div class="form__error" v-if="formModels[index] && formModels[index].startDateHasError">
                  Invalid date
                </div>
              </div>
              <div class="model__field">
                <Datepicker class="input input--default input--shadow" placeholder="End Date"
                  :config="statics.datePickerConfig" :value="formModels[index] ? formModels[index].endDate : null"
                  @change="handleDateInput($event, index, 'endDate', 'formModel')" />
              </div>
              <div class="model__field">
                <input type="text" class="input input--default input--shadow"
                  :class="{ 'input--error': formModels[index] && formModels[index].priceHasError }" placeholder="Price"
                  @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'price',
                      data: $event.target.value,
                    })
                    " />
                <div class="form__error" v-if="formModels[index] && formModels[index].priceHasError">
                  Invalid price value
                </div>
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="intervals"
                  :reduce="(interval) => interval.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                  :placeholder="intervals[3].name" @update:modelValue="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'interval',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field model__field--economy"
                v-if="model && model.model_categories && model.model_categories.length">
                <VSelect class="select select--default select--shadow" :options="model.model_categories"
                  :reduce="(category) => category.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                  placeholder="Economy" @update:modelValue="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'economy',
                      data: $event,
                    })
                    " />
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import Loading from "@/partials/Loading";
import statics from "@/statics";
import { parseBirthday } from "@/helpers/entityParsers";
//import { formatDisplayDate, formatDate } from "@/helpers/dateFormatters";
import { formatDate } from "@/helpers/dateFormatters";
import withPopper from "@/helpers/withPopper";

defineOptions({
  name: "Service"
});

const props = defineProps({
  service: {
    required: true,
    type: Object,
  },
  companyId: {
    required: true,
    type: Number,
  },
  deleteService: {
    required: true,
    type: Function,
  },
  servicesToDelete: {
    required: true,
    type: Array,
  },
  options: {
    required: false,
    type: Array,
  },
});

const store = useStore();

// Helper function to extract date value from Datepicker emit
const extractDateValue = (value) => {
  // If it's an Event object, get the value from the input element
  if (value instanceof Event) {
    const inputValue = value.target?.value;
    console.log('Event detected, extracting from target:', inputValue);
    if (inputValue) return inputValue;
    return null;
  }

  // If empty, return null
  if (!value) return null;

  // If it's an array (Flatpickr's selectedDates), return first element
  if (Array.isArray(value)) {
    const firstElement = value.length > 0 ? value[0] : null;
    if (firstElement instanceof Event) {
      const inputValue = firstElement.target?.value;
      if (inputValue) return inputValue;
      return null;
    }
    return firstElement;
  }

  // Otherwise return as-is (Date object or string)
  return value;
};

// Date handlers for Datepickers - properly extract date values
const handleDateInput = (value, index, key, modelType = 'formModel') => {
  const dateValue = extractDateValue(value);

  if (modelType === 'formModel') {
    store.commit('setSpecificFormModel', { index, key, data: dateValue });
  } else if (modelType === 'singletonModel') {
    store.commit('setSpecificSingletonFormModel', { index, key, data: dateValue });
  } else if (modelType === 'singleModel') {
    store.commit('setSpecificSingleModel', { key, data: dateValue });
  }
};

// State
const KVG = statics.KVG;
const maxUnderAgedIdFranchise = 7;
const teenage = 18;
const serviceLoading = ref(false);
const showModelsDropdown = ref(false);
const dropdownModels = ref([]);
const preModels = ref([]);
const models = ref([]);
const singletonModelIndex = ref(null);

// Computed
const language = computed(() => store.getters.language);
const policyForms = computed(() => store.getters.policyForms);
const customerDetails = computed(() => store.getters.customerDetails);
const formModels = computed(() => store.getters.formModels);
const singleModel = computed(() => store.getters.singleModel);
const singletonFormModels = computed(() => store.getters.singletonFormModels);
const servicesToRemove = computed(() => store.getters.servicesToRemove);

const isFirstServiceOfBranch = computed(() => {
  const allModels = [];

  if (props.service.id === KVG && preModels.value.length) {
    preModels.value.forEach((model) => allModels.push({ ...model, type: "KVG" }));
  } else if (singleModel.value && singleModel.value.serviceId) {
    allModels.push({ ...singleModel.value, type: "KVG" });
  }

  singletonFormModels.value.forEach((m, i) =>
    allModels.push({ ...m, type: "singleton", index: i })
  );
  formModels.value.forEach((m) => allModels.push({ ...m, type: "multiple" }));

  const firstModel = allModels.find(
    (m) => m.branch_category_id === props.service.branch_category_id
  );

  if (!firstModel) return false;

  switch (firstModel.type) {
    case "KVG":
      return (
        props.service.id === KVG &&
        (singleModel.value.id === firstModel.id ||
          models.value.some((m) => m.id === firstModel.id) ||
          preModels.value.some((m) => m.id === firstModel.id))
      );
    case "singleton":
      return firstModel.index === singletonModelIndex.value;
    case "multiple":
      return Array.isArray(models.value) && models.value.some((m) => m.id === firstModel.id);
    default:
      return false;
  }
});

const intervals = computed(() => policyForms.value.intervals);
const accidents = computed(() => [
  { title: "Yes", value: true },
  { title: "No", value: false },
]);
const franchises = computed(() => policyForms.value.franchises);
const dropdownFranchises = computed(() =>
  parseBirthday(customerDetails.value.birthday) <= teenage ? underAgedFranchises.value : agedFranchises.value
);
const underAgedFranchises = computed(() => franchises.value.filter((f) => f.id <= maxUnderAgedIdFranchise));
const agedFranchises = computed(() => franchises.value.filter((f) => f.id > maxUnderAgedIdFranchise));

// Watcher
watch(() => props.servicesToDelete, (services) => {
  if (services.length) {
    const serviceToDelete = services.find((s) => s.id === props.service.id);
    if (serviceToDelete && !servicesToRemove.value.some((s) => s.id === serviceToDelete.id)) {
      const { id } = serviceToDelete;
      let type = id === KVG ? "KVG" : (dropdownModels.value.length ? "multiple" : "singleton");
      store.commit("setServicesToRemove", [...servicesToRemove.value, { id, type }]);
    }
  }
});

// Lifecycle / Methods
onMounted(async () => {
  serviceLoading.value = true;
  dropdownModels.value = await store.dispatch("getModelsByCompanyServiceAndCustomer", {
    serviceId: props.service.id,
    companyId: props.companyId,
    customerId: customerDetails.value.id,
  });

  const isKVG = props.service.id === KVG;
  const hasNoModels = dropdownModels.value.length === 0;

  if (isKVG && !hasNoModels) {
    store.commit("setSingleModel", { ...singleModel.value, id: dropdownModels.value[0].id, serviceId: props.service.id, branch_category_id: props.service.branch_category_id, policy_statusHasError: false });
  } else if (hasNoModels) {
    const newSingleton = { serviceId: props.service.id, branch_category_id: props.service.branch_category_id, policy_number: "", policy_status_id: "", policy_statusHasError: false, submit_date: null, submit_dateHasError: false, startDate: "", endDate: formatDate(statics.lastDateOfCurrentYear), price: "", startDateHasError: false, priceHasError: false };
    if (singletonFormModels.value.findIndex(m => m.serviceId === props.service.id) === -1) {
      store.commit("setSingletonFormModels", [...singletonFormModels.value, newSingleton]);
    }
    if (isKVG) store.commit("setSingleModel", { id: "", serviceId: "" });
  }

  const finalIndex = singletonFormModels.value.findIndex(m => m.serviceId === props.service.id);
  singletonModelIndex.value = finalIndex !== -1 ? finalIndex : null;
  serviceLoading.value = false;
});

const addOrRemoveModels = (event, model) => {
  const { checked } = event.target;
  const idx = preModels.value.findIndex((m) => m.id === model.id);
  if (checked && idx === -1) {
    preModels.value = [...preModels.value, model];
    if (!formModels.value.some((m) => m.id === model.id)) {
      const master = [singleModel.value, ...formModels.value, ...singletonFormModels.value].find(m => m && m.branch_category_id === props.service.branch_category_id && m.policy_status_id);
      store.commit("setFormModels", [...formModels.value, { id: model.id, serviceId: props.service.id, branch_category_id: props.service.branch_category_id, policy_number: master?.policy_number || "", policy_status_id: master?.policy_status_id || "", submit_date: master?.submit_date || null, policy_statusHasError: false, submit_dateHasError: false, startDate: "", endDate: formatDate(statics.lastDateOfCurrentYear), startDateHasError: false, priceHasError: false }]);
    }
  } else {
    preModels.value.splice(idx, 1);
  }
};

const applyModels = () => {
  models.value = [...preModels.value];
  const formModelIds = models.value.map((m) => m.id);
  store.commit("setFormModels", formModels.value.filter((m) => formModelIds.includes(m.id)));
  showModelsDropdown.value = false;
};

const removeService = () => {
  if (props.service.id === KVG) {
    store.commit("setSingleModel", { ...singleModel.value, id: "", serviceId: "", startDate: "", franchise: "", accident: "", doctorName: "", price: "", interval: "", startDateHasError: false, priceHasError: false });
  } else if (!dropdownModels.value.length) {
    const singletonModels = [...singletonFormModels.value];
    singletonModels.splice(singletonModelIndex.value, 1);
    store.commit("setSingletonFormModels", singletonModels);
  } else {
    store.commit("setFormModels", []);
  }
  props.deleteService(props.service.id);
};
</script>

<style scoped lang="scss">
.non-kvg {
  display: flex;

  .service__field {
    flex: 1;
  }
}

.service,
.model {
  position: relative;
  min-height: 80px;

  &--multiple {
    padding: 20px 50px;
    border-bottom: 1px solid var(--border-10);

    .model__name {
      color: var(--text-2);
      font-family: var(--muli-text-semi-bold);
      font-size: var(--x-small);
      margin-bottom: 15px;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  &__name {
    font-size: var(--x-small);
    color: var(--text-5);
    margin-right: 15px;
  }

  &__fields {
    display: flex;
  }

  &__field {
    width: 110px;
    margin-right: 5px;
    position: relative;

    &--economy {
      width: 180px;
    }
  }

  .policy__service-toggler {
    margin: 0;
  }
}

.models {
  border-top: 1px solid var(--border-10);
  margin-top: 15px;
}

.select--model-dropdown {
  width: 280px !important;
  margin-bottom: 20px;
}

.number-status-fields {
  margin-bottom: 20px;
  justify-content: space-between;
  //flex-wrap: wrap;
  gap: 20px;

  .service__field {
    // width: 45%;
    flex: 1;
  }
}
</style>
